import React, { useContext } from 'react'
import { Typography, Button } from "@material-tailwind/react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { NewContext } from '../../Context/NewContext';

export const RatingModel = () => {
    const { handleClose, setDeleteUpdateYes, formData, open, confirmationModalShow, setConfirmationModalShow, setDeleteUpdateItem } = useContext(NewContext);

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "590px",
                            borderRadius: "12px" // Set your width here
                        },
                    },
                }}
            >
                <DialogContent>
                    <div>
                        <Dialog open={open}
                            onClose={handleClose}
                            aria-labelledby="responsive-dialog-title"
                            sx={{
                                "& .MuiDialog-container": {
                                    "& .MuiPaper-root": {
                                        width: "100%",
                                        maxWidth: "590px",
                                        borderRadius: "12px" // Set your width here
                                    },
                                },
                            }}
                        >
                            <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627] !text-[28px] font-medium leading-none'>
                                {"User Rating"}
                            </DialogTitle>

                            <DialogContent>
                                <div className="">
                                    <div className="mb-4 grid grid-cols-12 gap-2 pb-5">
                                        <div className="col-span-6 sm:col-span-8">
                                            <label htmlFor="name" className="block text-lg font-medium leading-5 text-[#1E3354]">App Name</label>
                                            <div className="mt-2">
                                                <Typography className="text-[17px] text-[#75869F] font-normal leading-5">{formData?.appName}</Typography>
                                            </div>
                                        </div>
                                        <div className="col-span-6 sm:col-span-4">
                                            <label htmlFor="name" className="block text-lg font-medium leading-5 text-[#1E3354]">Rating</label>
                                            <div className="mt-2">
                                                <Typography className="text-[17px] text-[#75869F] font-normal leading-5">{formData?.rating}</Typography>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-2 grid grid-cols-12 gap-2 pb-5">
                                        <div className="col-span-6 sm:col-span-8">
                                            <label htmlFor="name" className="block text-lg font-medium leading-5 text-[#1E3354]">Review</label>
                                            <div className="mt-2">
                                                <Typography className="text-[17px] text-[#75869F] font-normal leading-5">{formData?.review}</Typography>
                                            </div>
                                        </div>
                                        <div className="col-span-6 sm:col-span-4">
                                            <label htmlFor="name" className="block text-lg font-medium leading-5 text-[#1E3354]">Entry Date</label>
                                            <div className="mt-2">
                                                <Typography className="text-[17px] text-[#75869F] font-normal leading-5">{formData?.entryDate}</Typography>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='flex flex-row justify-center sm:justify-end mt-10 gap-2'>
                                        <Button onClick={() => { handleClose(); }}
                                            className="px-4 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                        >
                                            Cancel
                                        </Button>
                                        <Button className='bg-[#DD2B2B] text-white px-4 py-2.5 rounded-lg text-base leading-none font-medium shadow-none hover:shadow-none capitalize' onClick={() => { setDeleteUpdateYes("delete-rating"); setDeleteUpdateItem({ id: formData._id }); setConfirmationModalShow(!confirmationModalShow) }} >Delete</Button>
                                    </div>
                                </div>
                            </DialogContent>
                        </Dialog>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default RatingModel
